import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { updateConversionRate } from "../features/settings/settingsSlice";

// helper to check if a UNIX timestamp is from "today"
const isToday = (timestamp: number): boolean => {
  const now = new Date();
  const dateToCheck = new Date(timestamp * 1000);
  return (
    now.getUTCFullYear() === dateToCheck.getUTCFullYear() &&
    now.getUTCMonth() === dateToCheck.getUTCMonth() &&
    now.getUTCDate() === dateToCheck.getUTCDate()
  );
};

// your API endpoint
const EXCHANGE_API_URL = `https://v6.exchangerate-api.com/v6/${process.env.REACT_APP_CONVERSION_RATE_API}/latest/USD`;

export const useConversionRate = () => {
  const dispatch = useDispatch();
  const conversionRate = useSelector(
    (state: any) => state.settings.conversionRate
  );
  const lastUpdate = useSelector((state: any) => state.settings.lastUpdateUnix);

  const fetchAndUpdateRate = async () => {
    try {
      const response = await axios.get(EXCHANGE_API_URL);
      const data = response.data;

      if (data?.result === "success") {
        const twdRate = data.conversion_rates?.TWD;
        dispatch(
          updateConversionRate({
            rate: twdRate,
            lastUpdateUnix: data.time_last_update_unix,
          })
        );
        console.log("✅ Conversion rate updated:", twdRate);
      } else {
        console.warn("⚠️ Failed to get conversion rates:", data);
      }
    } catch (err) {
      console.error("❌ Error fetching exchange rate:", err);
    }
  };

  const checkConversionRate = async () => {
    if (!conversionRate || !lastUpdate || !isToday(lastUpdate)) {
      console.log("Fetching latest TWD rate...");
      await fetchAndUpdateRate();
    } else {
      console.log("✅ Conversion rate is up-to-date for today");
    }
  };

  return { checkConversionRate };
};
